// This icon file is generated automatically.
var PHomeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.79 6.9L7.75.85l-.4-.4a.5.5 0 00-.7 0L.21 6.88a1 1 0 00.72 1.7h.67v5.1h10.8v-5.1h.68a1 1 0 001-1 1 1 0 00-.3-.7zm-5.91 5.66H6.13V9.37h1.75v3.2zm3.4-5.09v5.1h-2.4V9a.62.62 0 00-.63-.63h-2.5a.62.62 0 00-.63.63v3.56h-2.4V7.47h-1.5L7 1.7l.36.36 5.42 5.41h-1.5z", "fill-rule": "nonzero" } }] }, "name": "p-home", "theme": "outlined" };
export default PHomeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PHomeOutlined.js
// module id = 3455
// module chunks = 0